export default __webpack_public_path__ + "static/media/phishing-indentify5.c775885f.png";